import { Box, Checkbox, TextInput } from '@ksyos/design-system';
import { useState } from 'react';

interface ISettingsCheckboxInputProps {
    error?: string;
    onChange: (value: string | null, checked?: boolean) => void;
    onDoValidate?: () => void;
    placeholder?: string;
    text: string | null;
}

export function SettingsCheckboxInput(props: ISettingsCheckboxInputProps) {
    const [isChecked, setIsChecked] = useState(props.text !== null);
    const [stateText, setStateText] = useState(props.text);

    return (
        <Box display="flex">
            <Box
                alignItems="start"
                display="flex"
                mr={2}
                mt={2}
            >
                <Checkbox
                    checked={isChecked}
                    onChange={(e) => handleCheckChange(e.target.checked)}
                />
            </Box>
            <Box width="100%">
                <TextInput
                    error={props.error}
                    onBlur={props.onDoValidate}
                    onChange={(e) => handleTextChange(e.target.value)}
                    placeholder={props.placeholder}
                    value={stateText ?? ''}
                />
            </Box>
        </Box>
    );

    function handleCheckChange(value: boolean) {
        const text = value ? props.text : null;
        setIsChecked(value);
        setStateText(text);
        props.onChange(text, value);
    }

    function handleTextChange(value: string | null) {
        setIsChecked(Boolean(value));
        setStateText(value);
        props.onChange(value || null, Boolean(value));
    }
}
